import React from 'react';
import {connect} from "react-redux";
import AuthService from "../../../../../services/AuthService";
import ActivitesPrincipalesTable from './comps/ActivitesPrincipalesTable';
import PointsAmeliorationTable from './comps/PointsAmeliorationTable';
import CompetencesTable from './comps/CompetencesTable';
import Alert from "../../../../shared/utils/Alert";

class Page4 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.Auth = new AuthService();
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={'row justify-content-md-center'}>
                <div className='col col-sm-10' style={{fontSize: 12}}>
                    <Alert text="Veuillez décrire le poste du salarié."/>
                    <ActivitesPrincipalesTable/>
                    <CompetencesTable/>
                    <PointsAmeliorationTable/>
                </div>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {}
}

export default connect(mapStateToProps)(Page4);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/Page4.js